import React, { useState } from "react";
import { reset_password_api } from "../../DAL/Users";
import { useSnackbar } from "notistack";
import { Icon } from "@iconify/react";
import SubmitButton from "../GeneralComponents/SubmitButton";
import {
  isPasswordStrongEnough,
  passwordPolicyMessage,
} from "../../utils/passwordPolicy";

export default function ResetPassword(props) {
  const { formData, setFormData, setErrors, errors, handleLogin } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [passwordType, setPasswordType] = useState({
    new_password: "password",
    confirm_password: "password",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.new_password.trim()) {
      newErrors.new_password = "New password is required";
    } else if (!isPasswordStrongEnough(formData.new_password)) {
      newErrors.new_password = passwordPolicyMessage;
    }
    if (!formData.confirm_password.trim()) {
      newErrors.confirm_password = "Please confirm your password";
    } else if (formData.new_password !== formData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    const postData = { ...formData };
    const result = await reset_password_api(postData);
    if (result.code === 200) {
      handleLogin();
    } else {
      enqueueSnackbar(`${result.message}`, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleChangeIcon = (name) => {
    const updateName = `${name}_password`;
    let password_type = "password";
    if (passwordType[updateName] === "password") {
      password_type = "text";
    }
    setPasswordType((old) => ({ ...old, [updateName]: password_type }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="new_password">New Password</label>
        <div className="input-wrapper">
          <input
            type={passwordType.new_password}
            id="new_password"
            name="new_password"
            value={formData.new_password}
            onChange={handleChange}
            placeholder="Enter new password"
            className={errors.new_password ? "has-error" : ""}
            autoComplete="new-password"
          />
          <Icon
            icon={`mdi:eye${
              passwordType.new_password === "password" ? "-off" : ""
            }`}
            className="eye-icon"
            onClick={() => handleChangeIcon(`new`)}
          />
        </div>
        {errors.new_password && (
          <span className="error-message">
            <Icon icon="mdi:alert-circle" className="error-icon" />
            {errors.new_password}
          </span>
        )}
      </div>
      <div className="form-group">
        <label htmlFor="confirm_password">Confirm Password</label>
        <div className="input-wrapper">
          <input
            type={passwordType.confirm_password}
            id="confirm_password"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleChange}
            placeholder="Confirm your password"
            className={errors.confirm_password ? "has-error" : ""}
            autoComplete="new-password"
          />
          <Icon
            icon={`mdi:eye${
              passwordType.confirm_password === "password" ? "-off" : ""
            }`}
            className="eye-icon"
            onClick={() => handleChangeIcon(`confirm`)}
          />
        </div>
        {errors.confirm_password && (
          <span className="error-message">
            <Icon icon="mdi:alert-circle" className="error-icon" />
            {errors.confirm_password}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <SubmitButton
          isLoading={isLoading}
          btnText="Reset Password"
          loadingText="Resetting..."
        />
        <button
          type="button"
          onClick={handleLogin}
          className="btn-secondary"
        >
          <Icon icon="mdi:arrow-left" className="btn-icon" />
          Back to Login
        </button>
      </div>
    </form>
  );
}
